import styled from "styled-components";
import BigWhiteX from "../assets/big-white-x.svg";

const Container = styled.div`
  height: 80px;
  width: 90vw;
  position: absolute;
  top: 0;
  right: 5%;
`;

const Close = styled.button`
  border: 0;
  position: absolute;
  background-color: var(--bg-dark-blue);
  height: 80px;
  width: 80px;
  top: 0;
  right: 0;
  border-radius: 0 0 10px 10px;

  &:hover {
    cursor: pointer;
  }
`;

const CloseSVG = styled.img`
  height: 25px;
  width: 20px;
  padding: 30px 28px 26px 27px;
`;

const CloseX = ({ handleClick, open }) => {
  return (
    <Container>
      <Close
        onClick={() => {
          handleClick(!open);
        }}
      >
        <CloseSVG src={BigWhiteX}></CloseSVG>
      </Close>
    </Container>
  );
};

export default CloseX;
